import React from 'react';
import { ANIMATION_IN, ANIMATION_OUT } from '../../../../../config/constants';
import { Row, Col } from 'reactstrap';
import { Animated } from 'react-animated-css';
import { RadioElement, RenderMultipleChoiceQuestion } from './exam-components';

export default class McqSingleAnswer extends React.Component<any, any> {
  constructor(props) {
    super(props);
  }

  state = {
    showAnswer: false,
    answer: null
  };

  componentWillUnmount() {
  }

  onChangeRadioValue = e => {
    this.props.onAnswer(e.target.value, this.props.question._id);
  } 
  
  render() {
    const { question } = this.props;
    return (
      <Animated animationIn={ANIMATION_IN} animationOut={ANIMATION_OUT} isVisible>
        <RenderMultipleChoiceQuestion name={ question._id } disabled={false} question= { question } onChangeRadioValue={ this.onChangeRadioValue } />
      </Animated>
    );
  }
}
